var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleLogo = function SvgGoogleLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.36 16.3635C31.36 15.229 31.2582 14.1381 31.0691 13.0908H16V19.2799H24.6109C24.24 21.2799 23.1127 22.9745 21.4182 24.109V28.1235H26.5891C29.6145 25.3381 31.36 21.2363 31.36 16.3635Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 31.9998C20.3194 31.9998 23.9412 30.5671 26.5884 28.1234L21.4175 24.1089C19.9848 25.0689 18.1521 25.6362 15.9994 25.6362C11.8321 25.6362 8.30481 22.8216 7.04663 19.0398H1.70117V23.1852C4.3339 28.4143 9.74481 31.9998 15.9994 31.9998Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04727 19.0402C6.72727 18.0802 6.54545 17.0547 6.54545 16.0002C6.54545 14.9456 6.72727 13.9202 7.04727 12.9602V8.8147H1.70182C0.618182 10.9747 0 13.4183 0 16.0002C0 18.582 0.618182 21.0256 1.70182 23.1856L7.04727 19.0402Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 6.36364C18.3484 6.36364 20.4575 7.17091 22.1157 8.75636L26.7048 4.16727C23.9339 1.58545 20.3121 0 15.9994 0C9.74481 0 4.3339 3.58545 1.70117 8.81454L7.04663 12.96C8.30481 9.17818 11.8321 6.36364 15.9994 6.36364Z",
    fill: "#EA4335"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-logo.92ba4d50.svg";
export { ForwardRef as ReactComponent };